import { MessageCircle, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function MoviePage() {
  const videoSrc = `${API_URL}/api/video/company-movie`;
  return (
    <div className="min-h-screen" style={{ background: '#111a4f' }} data-testid="movie-page">
      <SEOHead
        title="ChannelLoyalty.ai — The Film | AI Operating System for Channel Growth"
        description="Watch the ChannelLoyalty.ai company film — the AI-first channel loyalty platform for dealers, distributors, retailers and influencers."
        canonical="/movie"
      />
      <div className="max-w-5xl mx-auto px-4 py-12">
        <div className="text-center mb-8">
          <img src="/logo-white.png" alt="ChannelLoyalty.ai" className="h-16 mx-auto mb-5" />
          <h1 className="text-white text-3xl md:text-4xl font-bold">The AI Operating System for Channel Growth</h1>
          <p className="text-gray-300 mt-2">Watch how 50+ enterprise brands run loyalty for 100K+ channel partners</p>
        </div>

        <div className="rounded-2xl overflow-hidden shadow-2xl border border-white/10" data-testid="movie-player-wrap">
          <video
            controls
            playsInline
            preload="metadata"
            className="w-full block"
            data-testid="movie-player"
          >
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support video playback.
          </video>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 mt-8">
          <a
            href="https://wa.me/919910059861?text=Hi%20Chandra%2C%20I%20just%20watched%20the%20ChannelLoyalty%20film%20%E2%80%94%20let%27s%20talk."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-white transition-transform hover:scale-105"
            style={{ background: '#25D366' }}
            data-testid="movie-whatsapp-btn"
          >
            <MessageCircle size={20} /> WhatsApp Chandra Now
          </a>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold transition-transform hover:scale-105"
            style={{ background: '#7CC326', color: '#101846' }}
            data-testid="movie-demo-btn"
          >
            <Calendar size={20} /> Book a Free Demo
          </Link>
        </div>

        <p className="text-center text-gray-400 text-sm mt-8">
          Connect with Chandra · CBO · +91 99100 59861 · chandra@channelloyalty.ai
          <span className="block mt-1">Connect with Deepika · +91 99860 23182 · deepika@channelloyalty.ai</span>
        </p>
      </div>
    </div>
  );
}
